import '../Styles/Papers.css'

export function Schedule() {
    return (
        <>
        <h2><a target="_blank" href="/Kalender Altenburg 3 - Rahmenzeitplan.pdf">Schedule in German</a></h2>
        <h2><a target="_blank" href="/Kalender Altenburg 3 - Preliminary Schedule.pdf">Schedule in English</a></h2>
        </>
)
}